<div class="tunnel-page-container">
  <div class="body-container">
    <div class="bathroom-product-container">
      <ng-casto-tunnel-cart-panel></ng-casto-tunnel-cart-panel>
    </div>
  </div>

  <div class="action-bar-container">
    <ng-casto-action-bar
      [beforeNext]="beforeNextAction.bind(this)"
      [specificPrintAction]="printList.bind(this)"></ng-casto-action-bar>
  </div>
</div>
